import { companyInfo } from "@/mocks/site-data";

const stats = [
  { number: "4", label: "Sistemas Educacionais" },
  { number: "4", label: "Unidades no Brasil" },
  { number: "+10", label: "Anos de Experiência" },
  { number: "+1000", label: "Escolas Atendidas" },
];

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-start">
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
                Sobre Nós
              </span>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-6">
                Quem somos
              </h2>
              <div className="w-12 h-1 bg-accent-500 rounded-full mb-6" />
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
                {companyInfo.description}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                Nossa missão é democratizar o acesso à tecnologia de qualidade para instituições de ensino de todos os portes, desde pequenas escolas municipais até grandes redes de educação.
              </p>
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-50 border border-accent-200 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-sm" />
                  </div>
                  <span className="text-sm text-foreground-700">Tecnologia de ponta para educação</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-50 border border-accent-200 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-sm" />
                  </div>
                  <span className="text-sm text-foreground-700">Suporte técnico especializado</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-50 border border-accent-200 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-sm" />
                  </div>
                  <span className="text-sm text-foreground-700">Parcerias com universidades (UFC)</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8 text-center"
                >
                  <p className="text-3xl md:text-4xl font-bold text-primary-600 font-heading mb-2">
                    {stat.number}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500 font-medium">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}